import moment from 'moment'
moment.locale('es-AR')

export const setAuth = (state, payload) => {
  if (payload) {
    if (payload.nombre == 'Administrador') {
      payload.cod_agente = 9999;
    }

    sessionStorage.setItem('auth', JSON.stringify(payload));
    state.auth = payload;

  } else {
    sessionStorage.removeItem('auth');
    state.auth = {};
  }
};

export const storeAuth = state => {
  state.auth = JSON.parse(sessionStorage.getItem('auth'));
};

export const saveFilterCartera = (state, payload) => {
  state.filterCartera = payload;
};

export const resetFilterCartera = (state, payload) => {
  state.filterCartera = {
    tableIndex: payload.n,
    tableName: payload.name,
    search: '',
    start: 0,
    length: 10,
    ramo: 0,
    vig_desde: '',
    vig_hasta: '',
    refac_desde: '',
    refac_hasta: '',
    fec_emi_desde: '',
    fec_emi_hasta: '',
    cod_agente: state.auth.cod_agente
  }
}

export const setFiltroCodAgente = (state, value) => {
  //console.log('mutación ejecutada correctamente', value)
  state.filterCartera.cod_agente = value;
}

export const saveSelectedTable = (state, value) => {
  state.selectedTableCartera = value;
};

export const setRamos = (state, payload) => {
  state.ramos = payload;
};

export const setProductores = (state, payload) => {
  //console.log('set productores')
  state.productores = payload;
};

export const setProductoresComisionesRetenciones = (state, payload) => {
  //console.log('set productores de comisiones y retenciones')
  state.productoresComisionesRetenciones = payload;
};

export const setOrganizadores = (state, payload) => {
  // //console.log('set organizadores')
  state.organizadores = payload;
};

export const setTiposDeEndoso = (state, payload) => {
  // //console.log('set organizadores')
  state.tiposDeEndoso = payload;
};

export const setProductoresAsociados = (state) => {
  state.filterCartera.cod_agente = state.auth.cod_agente
  state.filterCartera.productores_asociados = state.productores.map(p => parseInt(p.cod_agente))
}
export const unsetProductoresAsociados = (state) => {
  delete state.filterCartera.productores_asociados
}

export const setAseguradosOptions = (state, payload) => {
  state.aseguradosOptions = payload;
};

export const setMonedas = (state, monedas) => {
  state.monedas = monedas;
};

export const setDashboardLoading = (state, value) => {
  state.dashboardLoading = value
}

export const setVencimientos = (state, value) => {
  state.vencimientos = value
}

export const setFilterVencimientos = (state, organizador)  => {
  const nextMonthStart = moment().add(1, 'months').date(1);
  const nextMonthEnd = moment().add(2, 'months').date(0);

  const filter = {
    vig_desde: nextMonthStart.format('Y-MM-DD'),
    vig_hasta: nextMonthEnd.format('Y-MM-DD'),
    cod_agente: state.auth.cod_agente
  };

  if (organizador) {
    filter.productores_asociados = state.productores.map(p => p.cod_agente)
  }

  filter.period = nextMonthStart.format('MMM Y').toUpperCase()

  state.filterVencimientos = filter
}

export const setAdeudadas = (state, value) => {
  state.adeudadas = value
}

export const setFilterAdeudadas = (state, organizador) => {
  const filter = {
    cod_agente: state.auth.cod_agente
  }
  if (organizador) {
    filter.productores_asociados = state.productores.map(p => p.cod_agente)
  }
  filter.period = moment().format('DD MMM Y').toUpperCase()
  state.filterAdeudadas = filter
}

export const setFilterRefacturacionesRc = (state, organizador) => {
  const nextMonthStart = moment().date(11);
  const nextMonthEnd = moment().add(1, 'months').date(10);
  const filter = {
    refac_desde: nextMonthStart.format('Y-MM-DD'),
    refac_hasta: nextMonthEnd.format('Y-MM-DD'),
    cod_agente: state.auth.cod_agente,
    cod_tipo_agente: state.auth.cod_tipo_agente
  }

  if (organizador) {
    filter.productores_asociados = state.productores.map(p => p.cod_agente)
  }
  filter.period = nextMonthStart.format('MMM Y').toUpperCase();
  state.filterRefacturacionesRc = filter
}

export const setRefacturacionesRc = (state, value) => {
  state.refacturacionesRc = value
}

export const setFilterRefacturacionesPer = (state, organizador) => {
  const nextMonthEnd = moment().endOf('month').date(0);

  const filter = {
    refac_hasta:nextMonthEnd.format('Y-MM-DD'),
    cod_agente: state.auth.cod_agente
  }

  if (organizador) {
    filter.productores_asociados = state.productores.map(p => p.cod_agente)
  }

  filter.period = nextMonthEnd.format('MMM Y').toUpperCase();
  state.filterRefacturacionesPer = filter

}

export const setRefacturacionesPer = (state, value) => {
  state.refacturacionesPer = value
}


export const setCategoriasRecursos = (state, data) => {
  state.recursos.categorias = data
}

export const delCategoriaRecursos = (state, id) => {
  const index = state.recursos.categorias.findIndex(el => el.id === id)
  state.recursos.categorias.splice(index, 1)
}

export const setPostsRecursos = (state, data) => {
  state.recursos.posts = data
}

/**
 * Guardo el tipo de dato ingresado en el buscador.
 * Los resultados en la ficha del tomador cambiarán
 * dependiendo si el usuario ingresó un número de póliza (int)
 * o el nombre de un asegurado (string)
 */
export const setTipoBusqueda = (state, data) => {
  state.tipoBusqueda = typeof data
}

export const setMenuProductor = (state, data) => {
  state.menuProductor = data;
}
